// src/pages/Home.jsx
import { developer } from '../models/portfolioData';
import resumePDF from '../assets/Ismail_Jabiulla_Flutter_Developer_Resume.pdf';

export default function Home() {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = resumePDF;
    link.download = 'Ismail_Jabiulla_Flutter_Developer_Resume.pdf';
    link.click();
  };

  const handleVisitWorks = (e) => {
    e.preventDefault();
    const el = document.getElementById('portfolio');
    if (el) {
      const yOffset = -70;
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <header id="home" className="header">
      <div className="overlay"></div>
      <div className="header-content container">
        <h1 className="header-title">
          <span className="up">HI!</span>
          <span className="down">I am {developer.name}</span>
        </h1>
        <p className="header-subtitle">
          {developer.role}
          <br />
          Flutter & Native iOS Developer
        </p>

        <div className="flex flex-wrap items-center gap-3">
          <a
            href="#portfolio"
            onClick={handleVisitWorks}
            className="btn btn-primary btn-rounded shadow-sm"
          >
            Visit My Works
          </a>
          <button
            onClick={handleDownload}
            className="btn btn-outline-primary btn-rounded shadow-sm"
          >
            Download CV
          </button>
        </div>
      </div>
    </header>
  );
}
